import { z } from 'zod/mini';

/**
 * The sign-in form is a single email. Domain membership is checked on the
 * server (issueMagicLink), never here — the form must accept any well-formed
 * address and give the same answer regardless, so it cannot be used to probe
 * which domains are allowed.
 */
export const RequestLink = z.object({
  email: z
    .email({
      error: (issue) =>
        issue.input === undefined
          ? 'Please enter your email.'
          : 'Please enter a valid email address.',
    })
    .check(z.trim(), z.toLowerCase(), z.maxLength(254)),
});

export type RequestLinkValues = z.infer<typeof RequestLink>;
